// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetMetadata} from './asset-metadata.js'
import {PDFLayoutBehavior} from './pdflayout-behavior.js'
import {Size} from './size.js'

export class PDFAsset {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFAsset {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFAsset(bb: flatbuffers.ByteBuffer, obj?: PDFAsset): PDFAsset {
    return (obj || new PDFAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFAsset(bb: flatbuffers.ByteBuffer, obj?: PDFAsset): PDFAsset {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  metadata(obj?: AssetMetadata): AssetMetadata | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetMetadata()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  layoutBehavior(): PDFLayoutBehavior {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : PDFLayoutBehavior.FitAndCropBox
  }

  totalPageCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 1
  }

  pagesConsumed(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 1
  }

  pageOffset(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  cropBoxes(index: number, obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? (obj || new Size()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  cropBoxesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startPDFAsset(builder: flatbuffers.Builder) {
    builder.startObject(6)
  }

  static addMetadata(builder: flatbuffers.Builder, metadataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metadataOffset, 0)
  }

  static addLayoutBehavior(builder: flatbuffers.Builder, layoutBehavior: PDFLayoutBehavior) {
    builder.addFieldInt8(1, layoutBehavior, PDFLayoutBehavior.FitAndCropBox)
  }

  static addTotalPageCount(builder: flatbuffers.Builder, totalPageCount: number) {
    builder.addFieldInt32(2, totalPageCount, 1)
  }

  static addPagesConsumed(builder: flatbuffers.Builder, pagesConsumed: number) {
    builder.addFieldInt32(3, pagesConsumed, 1)
  }

  static addPageOffset(builder: flatbuffers.Builder, pageOffset: number) {
    builder.addFieldInt32(4, pageOffset, 0)
  }

  static addCropBoxes(builder: flatbuffers.Builder, cropBoxesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, cropBoxesOffset, 0)
  }

  static startCropBoxesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static endPDFAsset(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // metadata
    builder.requiredField(offset, 14) // crop_boxes
    return offset
  }

  static createPDFAsset(
    builder: flatbuffers.Builder,
    metadataOffset: flatbuffers.Offset,
    layoutBehavior: PDFLayoutBehavior,
    totalPageCount: number,
    pagesConsumed: number,
    pageOffset: number,
    cropBoxesOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    PDFAsset.startPDFAsset(builder)
    PDFAsset.addMetadata(builder, metadataOffset)
    PDFAsset.addLayoutBehavior(builder, layoutBehavior)
    PDFAsset.addTotalPageCount(builder, totalPageCount)
    PDFAsset.addPagesConsumed(builder, pagesConsumed)
    PDFAsset.addPageOffset(builder, pageOffset)
    PDFAsset.addCropBoxes(builder, cropBoxesOffset)
    return PDFAsset.endPDFAsset(builder)
  }
}
